<template>
    <vx-table-row>
        <vx-table-row-title>
            <div class="vx-line-clamp-none vx-break-all lg:vx-line-clamp-3">
                {{ props.modelValue.name || '-' }}
            </div>
        </vx-table-row-title>

        <vx-table-row-buttons>
            <vx-button :href="`/settings/teams/${teamId}/group-collections/${props.modelValue.id}`"
                color="muted"
                outline>
                Go to Collection <font-awesome-icon :icon="faSquareArrowUpRight"/>
            </vx-button>
        </vx-table-row-buttons>
    </vx-table-row>
</template>
<script setup>
import {
    VxButton,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowTitle,
} from "@voxie/frontend-components";
import { faSquareArrowUpRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

const teamId = Spark.state.currentTeam.id;

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
});
</script>
